import React from "react";
import { withRouter, useLocation } from "react-router-dom";
import { PageHeader, Dropdown, Avatar, Typography } from "antd";
import shortid from "shortid";
import { Link, useHistory } from "react-router-dom";
import {
  DownOutlined,
  LogoutOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import {
  NavbarContainer,
  Menu,
  ProfileButton,
  NameContainer,
} from "./elements";
import { useUser } from "providers/user";

const { Text } = Typography;

function NavBar() {
  const { user, logout } = useUser();
  const { pathname } = useLocation();
  const { push } = useHistory();

  const handleLogout = async () => {
    await logout();
  };

  const format = (pathname) => {
    const title = pathname
      .substring(pathname.lastIndexOf("/") + 1)
      .replace(/-/g, " ");
    return title.charAt(0).toUpperCase() + title.slice(1);
  };

  return (
    <NavbarContainer>
      <Menu
        mode="horizontal"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <PageHeader
          style={{ marginRight: "auto", padding: "0px 20px" }}
          title={format(pathname)}
        />

        <Dropdown
          trigger={["click"]}
          overlay={
            <Menu mode="vertical">
              <Menu.ItemGroup title="Cuenta">
                <Menu.Item
                  key={shortid.generate()}
                  onClick={() => push("/settings")}
                  icon={<SettingOutlined />}
                >
                  Configuración
                </Menu.Item>
              </Menu.ItemGroup>
              <Menu.ItemGroup title="Sesión">
                <Menu.Item
                  key={shortid.generate()}
                  onClick={() => handleLogout()}
                  icon={<LogoutOutlined style={{ color: "red" }} />}
                >
                  <Link to={"/login"} style={{ color: "red" }}>
                    Salir
                  </Link>
                </Menu.Item>
              </Menu.ItemGroup>
            </Menu>
          }
        >
          <ProfileButton type="text">
            <Avatar
              style={{ marginRight: 15 }}
              size={35}
              src={user?.profileImg}
            >
              {user?.firstName?.[0]}
            </Avatar>
            <NameContainer>
              <Text style={{ fontSize: 12, color: "#4B89E3" }} type="secondary">
                Hola,
              </Text>
              <Text style={{ marginTop: -5, color: "#4B89E3" }} strong>
                {user?.email}
              </Text>
            </NameContainer>
            <DownOutlined />
          </ProfileButton>
        </Dropdown>
      </Menu>
    </NavbarContainer>
  );
}

export default withRouter(NavBar);
